var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _circle2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGogumaLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 18,
    fill: "#6b7280",
    stroke: "#ffffff",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 24,
    width: 3,
    height: 8,
    fill: "#ffffff",
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 20,
    width: 3,
    height: 12,
    fill: "#ffffff",
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 16,
    width: 3,
    height: 16,
    fill: "#ffffff",
    rx: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 12,
    width: 3,
    height: 20,
    fill: "#ffffff",
    rx: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 8,
    width: 3,
    height: 24,
    fill: "#ffffff",
    rx: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 12 L34 8 L38 12",
    stroke: "#374151",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 8 L34 16",
    stroke: "#374151",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 6,
    fill: "#374151"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 14,
    textAnchor: "middle",
    fill: "#ffffff",
    fontFamily: "Arial, sans-serif",
    fontSize: 8,
    fontWeight: "bold"
  }, "$")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGogumaLogo);
export default __webpack_public_path__ + "static/media/goguma-logo.f958941273eda6ffb1dc75c1098e6082.svg";
export { ForwardRef as ReactComponent };